import Vue from 'vue'
import Router from 'vue-router'

const login = r => require.ensure([], () => r(require('../page/login')), 'login')/*登录*/

const index = r => require.ensure([], () => r(require('../page/首页')), 'index')/*首页*/

const moreIcon = r => require.ensure([], () => r(require('../page/更多')), 'moreIcon')/*更多*/

const informationIndex = r => require.ensure([], () => r(require('../page/资讯首页')), 'informationIndex')/*资讯首页*/

const partyNews = r => require.ensure([], () => r(require('../page/党建要闻')), 'partyNews')/*党建要闻*/

const newsDetail = r => require.ensure([], () => r(require('../page/要闻详情')), 'newsDetail')/*要闻详情*/

const noticeBulletin = r => require.ensure([], () => r(require('../page/通知公告')), 'noticeBulletin')/*通知公告*/

const noticeDetail = r => require.ensure([], () => r(require('../page/公告详情')), 'noticeDetail')/*公告详情*/

const statuteList = r => require.ensure([], () => r(require('../page/党政法规')), 'statuteList')/*党政法规*/

const statuteDetail = r => require.ensure([], () => r(require('../page/法规详情')), 'statuteDetail')/*法规详情*/

const incorruptibleList = r => require.ensure([], () => r(require('../page/反腐倡廉')), 'incorruptibleList')/*反腐倡廉*/

const incorruptibleDetail = r => require.ensure([], () => r(require('../page/反腐详情')), 'incorruptibleDetail')/*反腐详情*/

const pioneerList = r => require.ensure([], () => r(require('../page/党建先锋')), 'pioneerList')/*党建先锋*/

const pioneerDetail = r => require.ensure([], () => r(require('../page/先锋详情')), 'pioneerDetail')/*先锋详情*/

const spareMemberList = r => require.ensure([], () => r(require('../page/预备党员')), 'spareMemberList')/*预备党员*/

const spareMemberDetail = r => require.ensure([], () => r(require('../page/预备党员详情')), 'spareMemberDetail')/*预备党员详情*/

const schoolAndCourse = r => require.ensure([], () => r(require('../page/党校党课')), 'schoolAndCourse')/*党校党课*/

const specialTopic = r => require.ensure([], () => r(require('../page/特色专题')), 'specialTopic')/*特色专题*/

const topicDetail = r => require.ensure([], () => r(require('../page/专题详情')), 'topicDetail')/*专题详情*/

const twoStudyOneDo = r => require.ensure([], () => r(require('../page/两学一做')), 'twoStudyOneDo')/*两学一做*/

const onlineCourse = r => require.ensure([], () => r(require('../page/在线党课')), 'onlineCourse')/*在线党课*/

const courseDetail = r => require.ensure([], () => r(require('../page/课程详情')), 'courseDetail')/*课程详情*/

const meetingList = r => require.ensure([], () => r(require('../page/三会一课')), 'meetingList')/*三会一课*/

const meetingDetail = r => require.ensure([], () => r(require('../page/会议详情')), 'meetingDetail')/*会议详情*/

const addMeeting = r => require.ensure([], () => r(require('../page/添加会议')), 'addMeeting')/*添加会议*/

const editSummary = r => require.ensure([], () => r(require('../page/编写纪要')), 'editSummary')/*编写纪要*/

const summaryDetail = r => require.ensure([], () => r(require('../page/纪要详情')), 'summaryDetail')/*纪要详情*/

const onlineExamination = r => require.ensure([], () => r(require('../page/在线考核')), 'onlineExamination')/*在线考核*/

const examinationPage = r => require.ensure([], () => r(require('../page/考试页面')), 'examinationPage')/*考试页面*/

const examinationDone = r => require.ensure([], () => r(require('../page/完成考试')), 'examinationDone')/*完成考试*/

const mathManual = r => require.ensure([], () => r(require('../page/数学微手册')), 'mathManual')/*数学微手册*/

const activityList = r => require.ensure([], () => r(require('../page/党建活动')), 'activityList')/*党建活动*/

const voteDetail = r => require.ensure([], () => r(require('../page/投票详情')), 'voteDetail')/*投票详情*/

const activityDetail = r => require.ensure([], () => r(require('../page/活动详情')), 'activityDetail')/*活动详情*/

const signInSuccess = r => require.ensure([], () => r(require('../page/报名成功')), 'signInSuccess')/*报名成功*/

const mine = r => require.ensure([], () => r(require('../page/我的')), 'mine')/*我的*/

const authentication = r => require.ensure([], () => r(require('../page/党员认证')), 'authentication')/*党员认证*/

const archivesList = r => require.ensure([], () => r(require('../page/党员档案')), 'archivesList')/*党员档案*/

const personalData = r => require.ensure([], () => r(require('../page/个人资料')), 'personalData')/*个人资料*/

const mailbox = r => require.ensure([], () => r(require('../page/党员信箱')), 'mailbox')/*党员信箱*/

const mailDetail = r => require.ensure([], () => r(require('../page/信箱详情')), 'mailDetail')/*信箱详情*/

const writeMail = r => require.ensure([], () => r(require('../page/写信')), 'writeMail')/*写信*/

const thoughtNotes = r => require.ensure([], () => r(require('../page/思想笔录')), 'thoughtNotes')/*思想笔录*/

const addNotes = r => require.ensure([], () => r(require('../page/新建笔录')), 'addNotes')/*新建笔录*/

const notesDetail = r => require.ensure([], () => r(require('../page/笔记详情')), 'notesDetail')/*笔记详情*/

const editPersonalData = r => require.ensure([], () => r(require('../page/信息完善')), 'editPersonalData')/*信息完善*/

const twoLearnDetail = r => require.ensure([], () => r(require('../page/两学一做详情')), 'twoLearnDetail')/*两学一做详情*/

const pdf = r => require.ensure([], () => r(require('../page/pdf.vue')), 'pdf')/*pdf*/


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      redirect: '/login'
    },
    {
      path: '/login',
      name: '登录',
      meta: { nokeepAlive: true, keepLogin: false },
      component: login
    },
    {
      path: '/index',
      name: '首页',
      meta: {nokeepAlive: true, keepLogin: false},
      component: index
    },
    {
      path: '/moreIcon',
      name: '更多',
      meta: {nokeepAlive: true, keepLogin: false},
      component: moreIcon
    },
    {
      path: '/informationIndex',
      name: '资讯首页',
      meta: {nokeepAlive: true, keepLogin: false},
      component: informationIndex
    },
    {
      path: '/partyNews',
      name: '党建要闻',
      meta: {nokeepAlive: false, keepLogin: false},
      component: partyNews
    },
    {
      path: '/newsDetail',
      name: '要闻详情',
      meta: {nokeepAlive: false, keepLogin: false},
      component: newsDetail
    },
    {
      path: '/noticeBulletin',
      name: '通知公告',
      meta: {nokeepAlive: false, keepLogin: false},
      component: noticeBulletin
    },
    {
      path: '/noticeDetail',
      name: '公告详情',
      meta: {nokeepAlive: false, keepLogin: false},
      component: noticeDetail
    },
    {
      path: '/statuteList',
      name: '党政法规',
      meta: {nokeepAlive: false, keepLogin: false},
      component: statuteList
    },
    {
      path: '/statuteDetail',
      name: '法规详情',
      meta: {nokeepAlive: false, keepLogin: false},
      component: statuteDetail
    },
    {
      path: '/incorruptibleList',
      name: '反腐倡廉',
      meta: {nokeepAlive: false, keepLogin: false},
      component: incorruptibleList
    },
    {
      path: '/incorruptibleDetail',
      name: '反腐详情',
      meta: {nokeepAlive: false, keepLogin: false},
      component: incorruptibleDetail
    },
    {
      path: '/pioneerList',
      name: '党建先锋',
      meta: {nokeepAlive: false, keepLogin: false},
      component: pioneerList
    },
    {
      path: '/pioneerDetail',
      name: '先锋详情',
      meta: {nokeepAlive: false, keepLogin: false},
      component: pioneerDetail
    },
    {
      path: '/spareMemberList',
      name: '预备党员',
      meta: {nokeepAlive: false, keepLogin: false},
      component: spareMemberList
    },
    {
      path: '/spareMemberDetail',
      name: '预备党员详情',
      meta: {nokeepAlive: false, keepLogin: false},
      component: spareMemberDetail
    },
    {
      path: '/schoolAndCourse',
      name: '党校党课',
      meta: {nokeepAlive: true, keepLogin: false},
      component: schoolAndCourse
    },
    {
      path: '/specialTopic',
      name: '特色专题',
      meta: {nokeepAlive: false, keepLogin: false},
      component: specialTopic
    },
    {
      path: '/topicDetail',
      name: '专题详情',
      meta: {nokeepAlive: false, keepLogin: false},
      component: topicDetail
    },
    {
      path: '/twoStudyOneDo',
      name: '两学一做',
      meta: {nokeepAlive: false, keepLogin: false},
      component: twoStudyOneDo
    },
    {
      path: '/onlineCourse',
      name: '在线党课',
      meta: {nokeepAlive: false, keepLogin: false},
      component: onlineCourse
    },
    {
      path: '/courseDetail',
      name: '课程详情',
      meta: {nokeepAlive: false, keepLogin: false},
      component: courseDetail
    },
    {
      path: '/meetingList',
      name: '三会一课',
      meta: {nokeepAlive: false, keepLogin: false},
      component: meetingList
    },
    {
      path: '/meetingDetail',
      name: '会议详情',
      meta: {nokeepAlive: false, keepLogin: false},
      component: meetingDetail
    },
    {
      path: '/addMeeting',
      name: '添加会议',
      meta: {nokeepAlive: true, keepLogin: false},
      component: addMeeting
    },
    {
      path: '/editSummary',
      name: '编写纪要',
      meta: {nokeepAlive: true, keepLogin: false},
      component: editSummary
    },
    {
      path: '/summaryDetail',
      name: '纪要详情',
      meta: {nokeepAlive: false, keepLogin: false},
      component: summaryDetail
    },
    {
      path: '/onlineExamination',
      name: '在线考核',
      meta: {nokeepAlive: false, keepLogin: false},
      component: onlineExamination
    },
    {
      path: '/examinationPage',
      name: '考核页面',
      meta: {nokeepAlive: true, keepLogin: false},
      component: examinationPage
    },
    {
      path: '/examinationDone',
      name: '完成考试',
      meta: {nokeepAlive: false, keepLogin: false},
      component: examinationDone
    },
    {
      path: '/mathManual',
      name: '数字微手册',
      meta: {nokeepAlive: true, keepLogin: false},
      component: mathManual
    },
    {
      path: '/activityList',
      name: '党建活动',
      meta: {nokeepAlive: false, keepLogin: false},
      component: activityList
    },
    {
      path: '/voteDetail',
      name: '投票详情',
      meta: {nokeepAlive: false, keepLogin: false},
      component: voteDetail
    },
    {
      path: '/activityDetail',
      name: '活动详情',
      meta: {nokeepAlive: false, keepLogin: false},
      component: activityDetail
    },
    {
      path: '/signInSuccess',
      name: '报名成功',
      meta: {nokeepAlive: true, keepLogin: false},
      component: signInSuccess
    },
    {
      path: '/mine',
      name: '我的',
      meta: {nokeepAlive: true, keepLogin: false},
      component: mine
    },
    {
      path: '/authentication',
      name: '党员认证',
      meta: {nokeepAlive: true, keepLogin: false},
      component: authentication
    },
    {
      path: '/archivesList',
      name: '党员档案',
      meta: {nokeepAlive: false, keepLogin: false},
      component: archivesList
    },
    {
      path: '/personalData',
      name: '个人资料',
      meta: {nokeepAlive: false, keepLogin: false},
      component: personalData
    },
    {
      path: '/mailbox',
      name: '党员信箱',
      meta: {nokeepAlive: true, keepLogin: false},
      component: mailbox
    },
    {
      path: '/mailDetail',
      name: '信箱详情',
      meta: {nokeepAlive: true, keepLogin: false},
      component: mailDetail
    },
    {
      path: '/writeMail',
      name: '写信',
      meta: {nokeepAlive: true, keepLogin: false},
      component: writeMail
    },
    {
      path: '/thoughtNotes',
      name: '思想笔录',
      meta: {nokeepAlive: true, keepLogin: false},
      component: thoughtNotes
    },
    {
      path: '/addNotes',
      name: '新建笔录',
      meta: {nokeepAlive: true, keepLogin: false},
      component: addNotes
    },
    {
      path: '/notesDetail',
      name: '笔记详情',
      meta: {nokeepAlive: true, keepLogin: false},
      component: notesDetail
    },
    {
      path: '/twoLearnDetail',
      name: '两学一做详情',
      meta: {nokeepAlive: false, keepLogin: false},
      component: twoLearnDetail
    },
    {
      path: '/editPersonalData',
      name: '信息完善',
      meta: {nokeepAlive: true, keepLogin: false},
      component: editPersonalData
    },
    {
      path: '/pdf',
      name: 'pdf',
      meta: {nokeepAlive: true, keepLogin: false},
      component: pdf
    },
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js